import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {
  FiPhoneCall,
  FiMapPin,
  FiCreditCard,
  FiCheckCircle,
  FiArrowRight
} = FiIcons;

const steps = [
  {
    number: '01',
    icon: FiPhoneCall,
    title: 'Book or Call',
    description: "Reach us online or by phone. Tell us what you need and when,we'll confirm a time the same day."
  },
  {
    number: '02',
    icon: FiMapPin,
    title: 'We Come to You',
    description: 'Home,office,hospital,or wherever works. Or meet us on video for Remote Online Notary.'
  },
  {
    number: '03',
    icon: FiCreditCard,
    title: 'Bring Your ID',
    description: "A valid government-issued photo ID and your unsigned document. Don't sign beforehand,we need to watch you sign."
  },
  {
    number: '04',
    icon: FiCheckCircle,
    title: 'Done and Sealed',
    description: 'We verify your identity,witness your signature,and complete the notarial act.'
  }
];

const HowItWorks = () => {
  return (
    <section className="py-24 px-6 bg-cream">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-brass text-xs font-bold tracking-[0.2em] uppercase mb-4 block">
            SIMPLE PROCESS
          </span>
          <h2 className="font-fraunces text-4xl md:text-5xl text-navy mb-6">
            Getting notarized
            <span className="italic text-brass">
              {' '}shouldn&apos;t be complicated.
            </span>
          </h2>
          <p className="text-lg text-navy/70 leading-relaxed">
            Here&apos;s what to expect from booking to done.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step,index) => (
            <motion.article
              key={step.number}
              initial={{ opacity: 0,y: 20 }}
              whileInView={{ opacity: 1,y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08 }}
              className="relative"
            >
              <div className="flex items-center gap-4 mb-8">
                <span className="w-12 h-12 rounded-full bg-navy text-cream flex items-center justify-center font-bold text-sm tracking-wider">
                  {step.number}
                </span>
                <div className="h-px bg-line flex-grow hidden lg:block" />
              </div>

              <div className="w-14 h-14 rounded-full border border-brass flex items-center justify-center text-brass mb-6">
                <SafeIcon icon={step.icon} size={25} />
              </div>

              <h3 className="font-fraunces text-2xl text-navy mb-4">
                {step.title}
              </h3>
              <p className="text-sm text-navy/70 leading-relaxed">
                {step.description}
              </p>
            </motion.article>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-16">
          <a
            href="/contact"
            className="w-full sm:w-auto flex items-center justify-center gap-3 bg-navy text-cream px-10 py-4 rounded-full text-base font-bold hover:bg-brass transition-colors shadow-lg group"
          >
            Book Your Appointment
            <SafeIcon
              icon={FiArrowRight}
              className="group-hover:translate-x-1 transition-transform"
            />
          </a>
          <a
            href="tel:2405713117"
            className="w-full sm:w-auto flex items-center justify-center bg-transparent border border-navy text-navy px-10 py-4 rounded-full text-base font-bold hover:bg-navy hover:text-cream transition-all"
          >
            Call or Text (240) 571-3117
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;